// Admin authentication and API utilities

// Per IONOS: l'API PHP està al mateix domini
const getApiBase = () => {
  // En producció (IONOS), l'API PHP està a /api/
  // En desenvolupament local, usa REACT_APP_BACKEND_URL
  if (process.env.NODE_ENV === 'production') {
    return '';  // Mateix domini
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const login = async (email, password) => {
  const apiBase = getApiBase();
  const response = await fetch(`${apiBase}/api/auth/login.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    throw new Error('Invalid email or password');
  }

  const data = await response.json();
  localStorage.setItem('token', data.access_token);
  localStorage.setItem('user', JSON.stringify(data.user));
  return data;
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const isAuthenticated = () => {
  return !!getToken();
};

// Convertir endpoints FastAPI a PHP
const convertEndpoint = (endpoint) => {
  // /api/auth/login -> /api/auth/login.php
  // /api/auth/me -> /api/auth/me.php
  // /api/projects -> /api/projects/index.php
  // /api/projects/:id -> /api/projects/single.php?id=:id
  // /api/admin/projects -> /api/projects/index.php (POST)
  // /api/admin/projects/:id -> /api/projects/single.php?id=:id (PUT/DELETE)
  // /api/profile -> /api/profile/index.php
  // /api/admin/profile -> /api/profile/index.php (PUT)
  
  // Auth endpoints
  if (endpoint === '/api/auth/login') return '/api/auth/login.php';
  if (endpoint === '/api/auth/me') return '/api/auth/me.php';
  
  // Profile endpoints
  if (endpoint === '/api/profile' || endpoint === '/api/admin/profile') {
    return '/api/profile/index.php';
  }
  
  // Projects endpoints
  const projectMatch = endpoint.match(/^\/api\/(admin\/)?projects\/(.+)$/);
  if (projectMatch) {
    return `/api/projects/single.php?id=${projectMatch[2]}`;
  }
  
  if (endpoint === '/api/projects' || endpoint === '/api/admin/projects') {
    return '/api/projects/index.php';
  }
  
  // Health check
  if (endpoint === '/api/health') return '/api/health.php';
  
  return endpoint;
};

// API helper with authentication
export const apiCall = async (endpoint, options = {}) => {
  const token = getToken();
  const apiBase = getApiBase();
  const phpEndpoint = convertEndpoint(endpoint);
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${apiBase}${phpEndpoint}`, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    // Token expired or invalid
    logout();
    window.location.href = '/admin/login';
    throw new Error('Unauthorized');
  }

  return response;
};
